<template>
  <div class="c-main">
    <section class="c-main--screen" :style="{'background-image': 'url(' + bg + ')'}">
      <h1>
        おトクな不動産が見つかる
        <p class="c-main--screen__kind">{{kind}}一戸建て</p>
        </h1>
      <div class="c-main--screen__logo"><img src="@/assets/logo-without-slogan.png" alt=""></div>
      <div class="c-main--screen--area">
        <div class="c-main--screen--area--wrap">
          <div>
            <select v-model="selectedPrefecture" class="c-main--screen--area--wrap__list" @change="onChangePrefCD">
              <option value="0">都道府県</option>
              <option v-for="(item, index) in preflist" :key="index" :value="item.pref_code">{{item.pref_name}}</option>
            </select>
          </div>
          <div>
            <select v-model="selectedCity" class="c-main--screen--area--wrap__list" :disabled="!isCityReady">
              <option value="0">市区町村</option>
              <option v-for="(item, index) in citylist" :key="index" :value="item.city_code">{{item.city_name}}</option>
            </select>
          </div>
        </div>
        <button class="c-main--screen--area--submit" @click="onClickSearch"><img :src="require('@/assets/icon-search-history-2.png')"></button>
      </div>
    </section>

    <section v-if="preflist.length > 0" class="c-main__AreaList">
      <h2 class="c-main__AreaList__heading" >エリアから探す</h2>
      <ul class="c-main__AreaList__list">
        <li class="c-main__AreaList__list__item" v-for="(item, index) in preflist " :key="index">
          <a :href="`/kodate/${path}area/${item.pref_code}/`" >{{`${item.pref_name}(${+item.count.toLocaleString()})`}}</a>
        </li>
      </ul>
    </section>
    <nav class="c-main--kind" v-if="arealists.all && arealists.shinchiku && arealists.chuko">
      <h4>都道府県別の物件一覧はこちら</h4>
      <ul class="c-main--kind--list">
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/">一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/" >全てのエリア ({{arealists.all.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.all" :key="index"><a :href="`/kodate/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/shinchiku/">新築一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/shinchiku/" >全てのエリア ({{arealists.shinchiku.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.shinchiku" :key="index"><a :href="`/kodate/shinchiku/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
        <li class="c-main--kind--list__item">
          <div class="c-main--kind--list__item__key"><a href="/kodate/chuko/">中古一戸建て</a></div>
          <div class="c-main--kind--list__item__value">
            <ul class="c-main--kind--list__item__value__list">
              <li class="c-main--kind--list__item__value__list__item"><a href="/kodate/chuko/" >全てのエリア ({{arealists.chuko.map(n=>n.count).reduce((n,m)=>{return n+m}).toLocaleString()}})</a></li>
              <li class="c-main--kind--list__item__value__list__item" v-for="(item, index) in arealists.chuko" :key="index"><a :href="`/kodate/chuko/area/${item.pref_code}/`" >{{`${item.pref_name} (${+item.count.toLocaleString()})`}}</a></li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <common-breadcrumb style="width:100%;margin:0" :breadcrumbType="'mainKind'" />
  </div>
</template>

<script>
// import Cookies from 'js-cookie';

import MixinAPIs from '@/plugins/mixin-api';
import Meta from '@/plugins/mixin-meta';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import bg1 from '@/assets/main-visual.png';

import CommonGoToTop from '@/components/parts/CommonGoToTop';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import SchoolDistrictsListSearch from '@/components/search/school-districts/SchoolDistrictsListSearch';
import CommonButton from '@/components/parts/button/CommonButton';
import IsMobile from '@/plugins/isMobile';

export default {
  name: 'MainContents',
  mixins: [MixinAPIs, IsMobile, Meta, BehaviorLogMixin],
  components: {
    CommonGoToTop,
    SchoolDistrictsListSearch,
    CommonButton,
    CommonBreadcrumb,
  },
  data() {
    return {
      bg: this.getBg(),
      preflist: [],
      arealists: {},
      isPreflist: true,
      citylist: [],
      isCitylist: true,
      isLoggedIn: false,
      pref: '0',
      city: '0',
      err: false,
      isCityReady: false,
      suggest: {
        data: {
          contents: [],
        },
      },
    };
  },
  watch: {
    preflist() {
      this.isPreflist = false;
    },
    selectedPrefecture() {
      this.onChangePrefCD();
    },
    citylist() {
      this.isCitylist = false;
    },
  },
  computed: {
    selectedPrefecture: {
      set(newValue) {
        this.pref = newValue;
      },
      get() {
        const selectedPrefAvailable = this.preflist.find(a => a.pref_id === this.pref);
        return selectedPrefAvailable ? this.pref : '0';
      },
    },
    selectedCity: {
      set(newValue) {
        this.city = newValue;
      },
      get() {
        const selectedCityAvailable = this.citylist.find(a => a.city_code === this.city);
        return selectedCityAvailable ? this.city : '0';
      },
    },
    isBtnDisp() {
      return this.isMobile;
    },
    kind() {
      let ret;
      switch (this.$route.meta.kind) {
        case 1:
          ret = '新築';
          break;
        case 2:
          ret = '中古';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
    path() {
      let ret;
      switch (this.$route.meta.kind) {
        case 1:
          ret = 'shinchiku/';
          break;
        case 2:
          ret = 'chuko/';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
  },
  async created() {
    this.getUserLastSearchedArea();
    // 都道府県リスト取得
    this.preflist = await this.getPrefectureList(1, this.$route.meta.kind);
    this.arealists = {
      all: await this.getPrefectureList(1, 0),
      shinchiku: await this.getPrefectureList(1, 1),
      chuko: await this.getPrefectureList(1, 2),
    };
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
    // 検索コードCookie
    // if (Cookies.get('searchPref') !== undefined) {
    //   this.pref = Cookies.get('searchPref');
    //   await this.onChangePrefCD();
    //   this.city = Cookies.get('searchCity');
    // }
  },
  mounted() {
    let metakind = null;
    if (this.$route.meta.kind === 0) {
      metakind = 'kodate';
    } else if (this.$route.meta.kind === 1) {
      metakind = 'shinchiku';
    } else if (this.$route.meta.kind === 2) {
      metakind = 'chuko';
    }
    this.metaSetForDefault(metakind);
  },
  methods: {
    async getUserLastSearchedArea() {
      const lastSearchedArea = await this.getLastSearchedArea();
      this.pref = lastSearchedArea.prefId;
      this.prefilledCity = lastSearchedArea.cityId;
    },
    async onChangePrefCD() {
      this.isCityReady = false;
      if (this.prefilledCity) {
        this.selectedCity = this.prefilledCity;
        this.prefilledCity = null;
      } else {
        this.selectedCity = 0;
      }
      this.citylist = await this.getCityList(1, this.selectedPrefecture, this.$route.meta.kind);
      this.isCityReady = true;
    },
    getBg() {
      const rand = Math.floor(Math.random() * Math.floor(1));
      const bg = [bg1];
      return bg[rand];
    },
    onClickSearch() {
      let uri;
      if (this.$route.meta.kind === 0) {
        uri = '/kodate/area';
      } else {
        uri = `/kodate/${this.$route.meta.kind === 1 ? 'shinchiku' : 'chuko'}/area`;
      }
      if (this.pref === '0') {
        this.err = true;
      } else {
        // Cookies.set('searchPref', this.pref, {
        //   expires: 1 / 24,
        // });
        // Cookies.set('searchCity', this.city, {
        //   expires: 1 / 24,
        // });
        location.href = this.city !== 0 && this.city !== '0' ? `${uri}/${this.selectedPrefecture}/${this.city}/` : `${uri}/${this.selectedPrefecture}/`;
      }
    },
  },
};

</script>

<style scoped lang="scss">
@charset "UTF-8";
.c-main {
  background-color: #FFF;
  &--screen {
    width:100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 20%;
    padding: 8% 0 5%;
    h1 {
      width:100%;
      text-align: center;
      font-size: 36px;
      margin: 0 auto;
      color:#000000;
      font-family: "游明朝", "YuMincho", "ヒラギノ明朝 ProN W6", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif;
    }
    &__kind {
      margin-top: 20px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #E83532;
      font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, sans-serif;
    }
    &__logo {
      text-align: center;
      margin-top: 20px;
      img {
        display: block;
        margin: 10px auto 0;
        width: 265px;
        height: 36px;
      }
    }
    &--area {
      width: 100%;
      max-width:730px;
      margin: 45px auto 0;
      position: relative;
      &--wrap {
        width: calc(100% - 65px);
        max-width: 660px;
        margin-right:55px;
        display:flex;
        position: relative;
        & > div {
          width: 50%;
          margin: 0 10px;
          height: 52px;
          background: rgba(255,255,255,0.6);
          border-radius: 10px;
          overflow: hidden;
          position: relative;
        }
        &__list {
            padding: 17px;
            width: 100%;
            height: 100%;
            font-size: 14px;
            border: 0;
            cursor: pointer;
            background-color: rgba(255,255,255,0.6);
            appearance: none;
                -webkit-appearance: none;
        }
        & > div:after {
          content:'';
          position:absolute;
          bottom: 12px;
          right: 12px;
          width: 25px;
          height: 25px;
          background-size: cover;
          background-image:url('/static/img/icon-sort-2.png');
          pointer-events: none;
        }
      }
      &--submit {
        background-color: #E83532;
        border-radius: 10px;
        width:52px;
        height:52px;
        display:flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        right:10px;
        bottom:0;
        img {
          display:block;
          width:25px;
          height:25px;
        }
      }
    }
  }

  &--area {
    background-color: #FAFAFA;
    width:100%;
    padding: 20px;
    padding-top:30px;
    h4 {
      width: 100%;
      max-width: 500px;
      margin:auto;
      color: #E83532;
      font-weight: bold;
    }
    &--list {
      width: 100%;
      max-width: 500px;
      margin:20px auto;
      &__item {
        display:flex;
            margin-top: 20px;

        &__key {
          width:100px;
          font-weight: bold;
          line-height:1.7em;
        }
        &__value{
          width: calc(100% - 100px);

          &__list {
            display:flex;
            flex-wrap: wrap;
            &__item {
              margin-left:20px;
              line-height:1.7em;
            }
          }
        }
      }
    }
  }
  &--kind {
    background-color: #FAFAFA;
    width:100%;
    padding: 20px;
    padding-top:30px;

    h4 {
      width: 100%;
      max-width: 775px;
      margin:auto;
      color: #E83532;
      font-weight: bold;
      text-align:center;
    }
    &--list {
      width: 100%;
      max-width: 775px;
      margin:20px auto;
      &__item:nth-child(n+2) {
        color:lightgray;
      }
      &__item {
        display:flex;
            margin-top: 20px;

        &__key {
          width:100px;
          font-weight: bold;
          line-height:1.7em;
        }
        &__value{
          width: calc(100% - 100px);

          &__list {
            display:flex;
            flex-wrap: wrap;
            &__item {
              margin-left:20px;
              line-height:1.7em;
            }
          }
        }
      }
    }
  }
  &__AreaList {
    width: 100%;
    padding: 40px 0;
    background-color: #FAFAFA;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: center;
      margin-top:30px;
      &__item {
        margin:0 10px;
      }
    }
  }
  &__SugguestProperty {
    width: 100%;
    max-width: 1118px;
    margin: 40px auto 0;
    padding-bottom:40px;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__text {
      margin: 20px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: space-between;
      &__item {

      }
    }
  }
}
@media screen and (max-width:999px){
  .c-main--screen {
    padding: 8% 0 5%;
    h1 {
      font-size: 24px;
      img {
        width: 200px;
        height: 27px;
      }
    }
    &__kind {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #E83532;
    }
    &__logo {
      img {
        width: 200px;
        height: 27px;
      }
    }
  }
  .c-main--suggest--list {
    justify-content: center;
    padding: 0 20px;
    margin-top:30px;
  }
  .c-main--suggest--list__item figure {
    width: 80px;
    height: 80px;
  }
  .c-main--suggest--list__item article {
    h3 {
      font-size: 16px;
    }
    p {
      margin-top: 5px;
      line-height: 1.5;
      font-weight: normal;
    }
  }
  .c-main--school-search {
    background-color: #FAFAFA;
    margin-top: 40px;

    .search-wrapper {
      width: 512px;
      margin: auto;
    }
  }
  .c-main--blog {
    padding: 0 20px;
    h2 {
      width: 100%;
    }
  }
  .c-main--blog--box {
    max-width: 360px;
  }
  .c-main--blog--box:nth-of-type(even) article {
    padding-right: 0;
  }
}

@media screen and (max-width:767px){
  .c-main {
    &--screen {
      min-height: 211px;
      padding: 12% 0 6%;
      h1 {
        font-size: 14px;
        font-weight: bold;
        img {
          display: block;
          margin: 10px auto 0;
          width: 132px;
          height: 18px;
        }
      }
      &--kind {
        width: 100%;
        max-width: 360px;
        margin: 0px auto 0;
        padding-top: 30px;
        display:flex;
        justify-content: space-evenly;
        li {
          color:#FFF;
          font-size:18px;
          text-shadow: 2px 2px 2px rgba(0,0,0,0.5);
        }
      }
      &--area {
      margin: 25px auto 0;
      }
    }
    &--suggest {
      h2 {
        font-size: 14px;
        font-weight: bold;
        margin: 23px auto 0px;
      }
      &--list {
        width: calc(100% - 40px);
        padding: 0;
        margin-top: 20px;

        &__itemWrapper {
          margin: 0 0 10px 0 !important;
          width: 100%;
        }
        &__itemWrapper:last-child {
          margin-bottom: 0px !important;
        }
        &__item {
          width: 100%;
          padding: 10px;
          figure {
              width:80px;
              height:80px;
            img {
              width:100%;
            }
          }
          article {
            width: calc(100% - 60px);
            padding-left: 10px;
            h3 {
              line-height: 1.5;
              font-size: 16px;
            }
            p {
              margin-top: 5px;
              line-height: 1.4em;
              font-weight: normal;
              -webkit-line-clamp: 2;
            }
            span {
              bottom: 0;
              right:0;
              text-align: right;
            }
            a {
              display:none;
            }
          }
        }

      }
    }
    &--school-search {
      margin-top: 30px;
      .search-wrapper {
        width: 100%;
        margin: auto;

      }
    }
    &--blog {
      padding: 0;
      h2 {
        margin-left: 20px;
      }
      &--box {
        margin: 20px;
        max-width: 100%;
        h3 {
          img {
            vertical-align:middle;
          }
        }
        &--list {
          margin-top:12px;
          li:not(:first-child) {
            margin-top:10px;
          }
          li {
            a {
              display: flex;
              figure {
                img {
                width: 100%;
                }
              }
              article {
                max-width: 100%;
                padding-right: 0;
                h4 {
                  font-weight: bold;
                }

              }
            }
          }
        }
      }
    }
  &--kind {
    h4 {
      text-align: left;
    }
  }
  &__AreaList {
    width: 100%;
    max-width: 1118px;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__list {
      display:flex;
      justify-content: start;
      flex-wrap: wrap;
      padding: 0 10px;
      &__item {
        margin: 10px;
      }
    }
  }
  &__SugguestProperty {
    &__heading {
    }
    &__text {
      margin: 20px;
    }
    &__list {
      justify-content: space-evenly;
      flex-wrap: wrap;
      width: 346px;
      margin: auto;
      &__item {
        width:  100%;
      }
      &__item:nth-child(2) {
        margin-top:20px;
      }
      &__item:nth-child(3) {
        display: none;
      }
    }
  }
  }
}

.c-bread {
  background-color: #FAFAFA;
  display: flex;
  padding: 20px;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      line-height: 1.7em;
      margin-left: 4px;
      a {
        font-size: 13px;
        color: #E83532;
      }
      span {
        font-size: 13px;
      }
    }
    li:not(:first-child)::before {
      content: "> ";
      margin-left: 4px;
    }
  }
  &--icon {
    width: 50px;
  }
}

</style>
